export const KINDS = {
  currency: { label: "Game Currency", hint: "jumlah currency yang Anda miliki" },
  service: { label: "Game Services", hint: "kapasitas = jumlah order/slot yang sanggup Anda kerjakan bersamaan" },
};
export const qtyLabel = (kind, unit) => (kind === "service" ? "Kapasitas (order/slot)" : `Jumlah Currency${unit ? ` (${unit})` : ""}`);
export const fmtAmount = (e) => `${new Intl.NumberFormat("id-ID").format(e.quantity)} ${e.kind === "service" ? "slot" : e.unit || "unit"}`;
export const sel = "mt-2 bg-[#191A1F] border border-[#35353B] focus:border-[#D4AF37] text-[#F5F3ED] rounded-sm px-3 py-2 w-full outline-none text-sm";
export const lbl = "text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]";
